/** Above this, the badge reads `9+` — an exact count stops being useful. */
export const INBOX_BADGE_DISPLAY_CAP = 9;

/** The new-item count as shown on the sidebar badge and in the tab title. */
export function formatInboxBadgeCount(count: number): string {
  return count > INBOX_BADGE_DISPLAY_CAP ? `${INBOX_BADGE_DISPLAY_CAP}+` : String(count);
}
